import dashboard from "./menu/dashboard";
import administrator from "./menu/administrator";
import rolePermission from "./menu/rolePermission";
import company from "./menu/company";
import senior from "./menu/senior";
import master from "./menu/master";
import agent from "./menu/agent";
import player from "./menu/player";
import transaction from "./menu/transaction";
import balanceReport from "./menu/balanceReport";
import result from "./menu/result";
import betSetting from "./menu/betSetting";
import liveBet from "./menu/liveBet";

export default [
  ...dashboard,
  ...administrator,
  ...rolePermission,
  ...result,
  ...company,
  ...senior,
  ...master,
  ...agent,
  ...player,
  ...liveBet,
  ...transaction,
  ...balanceReport,
  ...betSetting,
]
